import {create, load_one, remove, update} from '@/store/action-helpers'

export default {

    create: create('additional-costs'),
    loadOne: load_one('additional-costs/:id'),
    remove: remove('additional-costs'),
    update: update('additional-costs/:id'),

}
